<template>
  <div class="sim">
    <MenuMovilTP />
    <MenuMovilUni />
    <main class="container">
      <Titulo titulo="SIMULADOR DE" subTitulo="PONDERACIONES" />
      <Formulario
        @simular="simularPonderacion"
        @resultados="asignarResultados"
      />
    </main>
    <main class="container mb-4 d-none d-lg-block">
      <b-alert class="mt-3" dismissible v-model="showAlert" show
        >Los datos enviados para realizar la simulación no produjeron ningun
        resultado.</b-alert
      >
      <Resultados :resultados="resultados" />
    </main>
    <ResultadosMovil :resultados="resultados" />
  </div>
</template>

<script>
import Titulo from "@/components/generales/paginas/TituloPagina";
import Formulario from "@/components/simuladorPonderaciones/Formulario";
import Resultados from "@/components/simuladorPonderaciones/ResultadosTabla";
import ResultadosMovil from "@/components/simuladorPonderaciones/ResultadosMovil";
import ApiUniversidades from "@/services/ApiUniversidades";
import { MensajesDeCarga } from "@/utils/BusesDeEventos.js";
import { mapGetters } from "vuex";
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";
export default {
  name: "SimuladorPonderaciones",
  components: {
    Titulo,
    Formulario,
    Resultados,
    ResultadosMovil,
    MenuMovilTP,
    MenuMovilUni
  },
  data() {
    return {
      resultados: [],
      showAlert: false
    };
  },
  mounted() {
    this.reiniciarBusqueda();
  },
  computed: {
    ...mapGetters(["getDataSimulacion"])
  },
  methods: {
    asignarResultados(res) {
      this.resultados = res;
    },
    async simularPonderacion(valores) {
      MensajesDeCarga.$emit("cargar");
      let resultados = await ApiUniversidades.obtenerSimulacionPonderaciones(
        valores
      );
      this.showAlert = false;
      if (resultados !== "") {
        resultados = this.ordenarData(resultados);
        this.resultados = resultados;
      } else {
        this.showAlert = true;
        this.resultados = [];
      }
      MensajesDeCarga.$emit("cargado");
    },
    ordenarData(listado) {
      let ordenado;
      ordenado = listado.sort((a, b) => {
        return a.institucion.localeCompare(b.institucion);
      });
      ordenado = ordenado.sort((a, b) => {
        let n1 =
          a.puntajeSimuladoPDT !== "*"
            ? a.puntajeSimuladoPDT.replace(",", ".")
            : 0;
        let n2 =
          b.puntajeSimuladoPDT !== "*"
            ? b.puntajeSimuladoPDT.replace(",", ".")
            : 0;
        return n2 - n1;
      });
      return ordenado;
    },
    reiniciarBusqueda() {
      let dataSimulacion = this.getDataSimulacion;
      if (Object.entries(dataSimulacion).length !== 0) {
        MensajesDeCarga.$emit("cargar");
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/SimuladorPonderaciones.vue